export default __webpack_public_path__ + "static/media/BSW.a5bec06d.svg";